module.exports = __webpack_public_path__ + "static/media/error-inactive.f8a877ac.jpg";